import type { CSSProperties } from 'react';
import { ApiError } from '../net/client';
import type { Refusal } from '../session/refusals';
import { colors, fonts, verdict } from '../theme';

/** Sign-in's form values that are not components, shared with joining, L1. */

/** A `validation_failed` whose details name a drawn field, keyed as `body.email`. Null when none does. */
export function fieldDetails<F extends string>(
  error: unknown,
  fields: { [K in F]: string } | readonly F[],
): Partial<Record<F, Refusal>> | null {
  if (!(error instanceof ApiError) || error.code !== 'validation_failed') return null;
  const pairs: [F, string][] = Array.isArray(fields)
    ? (fields as readonly F[]).map((f) => [f, f])
    : (Object.entries(fields) as [F, string][]);
  const out: Partial<Record<F, Refusal>> = {};
  for (const [field, key] of pairs) {
    const message = error.details?.[`body.${key}`];
    if (message !== undefined) out[field] = { message };
  }
  return Object.keys(out).length > 0 ? out : null;
}

/** A refused field's border is the refusal ink, mobile D97 section 4. */
export function borderFor(refusal: Refusal | undefined): string {
  return refusal !== undefined ? verdict.unknown.fg : colors.line;
}

/** `Welcome.dc.html:37`. */
export const input: CSSProperties = {
  height: 52,
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: 14,
  background: colors.card,
  border: `1px solid ${colors.line}`,
  padding: '0 16px',
  fontFamily: fonts.text,
  fontSize: '16px',
  color: colors.navy,
};

/** `Welcome.dc.html:39` and `OtpEntry.dc.html`'s Verify. Disabled in the mobile app's disabled pair. */
export function primary(enabled: boolean): CSSProperties {
  return {
    height: 52,
    borderRadius: 26,
    border: 'none',
    background: enabled ? colors.brand : colors.disabledBg,
    color: enabled ? colors.white : colors.disabledFg,
    fontFamily: fonts.display,
    fontWeight: 700,
    fontSize: '16px',
    cursor: enabled ? 'pointer' : 'default',
  };
}

export const stepForm: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
};
